import {NEW} from "@/modules/delivery/constants/OrderStates";
import {AS_SON_AS_POSIBLE, DELIVERY, SCHEDULED, TAKE_AWAY, SALON} from "@/modules/delivery/constants/OrderDelivery";
import OrderItem from "@/modules/delivery/core/models/OrderItem";
import dayjs from "dayjs";

class Order {
    constructor(Order = {
        id: null,
        identifier: null,
        number: null,
        origin: null,
        state: NEW,
        branch: null,
        minimunQuantity: 0,
        delivery: {mode: null, timeMode: null, date: dayjs().startOf('day'), time: null, cost: 0,  distance: null, onBar: false, longDistance: false},
        contact: { name: null, phone: null, email: null, observations: null },
        location: { address: "", floor: null, apartment: null, latitude: null, longitude: null, country: null, province: null, locality: null},
        payment: {method: null, receiptFile: null, transactionId: null, confirmed: false},
        items: [],
        discountRate: null,
        discountAmount: null,
        deliveryFree: false,
        employee: false
    }) {
        this.className = "Order"


        const {
            id = null,
            identifier= null,
            number= null,
            origin = null,
            state = NEW,
            branch = null,
            minimunQuantity = 0,
            delivery = {mode: null, date: dayjs().startOf('day'), timeMode: null, time: null, cost: 0,  distance: null, onBar: false, longDistance: false},
            contact = { name: null, phone: null, email: null, observations: null },
            location = {  address: "", floor: null, apartment: null, latitude: null, longitude: null, country: null, province: null, locality: null, place_id: null },
            payment = { method: null, receiptFile: null, transactionId: null, confirmed: false },
            items = [],
            discountRate = null,
            discountAmount = null,
            employee = false,
            deliveryFree = false
        } = Order

        this.id = id
        this.identifier = identifier
        this.number = number
        this.origin = origin
        this.state = state
        this.branch = branch
        this.minimunQuantity = minimunQuantity

        //Discounts
        this.employee = employee
        this.discountRate = discountRate
        this.discountAmount = discountAmount
        this.deliveryFree = deliveryFree

        this.items = items.map(i => new OrderItem(i))


        this.delivery = {
            mode: delivery.mode, //TAKE_WAY or DELIVERY
            timeMode: delivery.timeMode, //AS_SOON_AS_POSIBLE or SCHEDULED
            date: id ? delivery.date : dayjs().startOf('day'),
            time: delivery.time,
            cost: delivery.cost,
            distance: delivery.distance,
            longDistance: delivery.longDistance,
            onBar: delivery.onBar,
        }

        this.contact = {
            name: contact.name,
            phone: contact.phone,
            email: contact.email,
            observations: contact.observations
        }

        this.location = {
            localityFilter: location.localityFilter,
            address: location.address,
            floor: location.floor,
            apartment: location.apartment,
            latitude: location.latitude,
            longitude: location.longitude,
            country: location.country,
            province: location.province,
            locality: location.locality,
            postalCode: location.postalCode,
            place_id: location.place_id
        }

        this.payment = {
            method: payment.method,
            receiptFile: payment.receiptFile,
            transactionId: payment.transactionId,
            confirmed: payment.confirmed
        }


        this.error = null

    }


    get getDeliveryMode() {
        return this.delivery.mode
    }

    get getDeliveryTimeMode() {
        return this.delivery.timeMode
    }

    get getTime(){
        return this.delivery.time
    }

    get getDate(){
        return this.delivery.date
    }

    get isTakeAway() {
        return this.delivery.mode === TAKE_AWAY
    }

    get isDelivery() {
        return this.delivery.mode === DELIVERY
    }

    get isSalon() {
        return this.delivery.mode === SALON
    }

    get isAsSoonAsPossible() {
        return this.delivery.timeMode === AS_SON_AS_POSIBLE
    }

    get isScheduled() {
        return this.delivery.timeMode === SCHEDULED
    }


    setError(val) {
        this.error = val
    }


}

export default Order
